<template>
  <i-ic-sharp-celebration />
</template>
